<template>
  <messages-area :api="api" profile="partner" />
</template>

<script>
import MessagesArea from "@/components/messages/MessagesArea.vue";
import pitchPartnerApi from "@/shared/pitchPartnerApi";

// Card 17trt6jbffe: Mensagens do professor.
export default {
  name: "PartnerMessages",
  components: { MessagesArea },
  data() {
    return { api: pitchPartnerApi };
  },
};
</script>
